import zhCH from "./i18n/interface/zh-CN.js"
import zhTW from "./i18n/interface/zh-TW.js"
import fr from "./i18n/interface/fr.js"
import de from "./i18n/interface/de.js"
import ru from "./i18n/interface/ru.js"
import store from './store'


const textmap = {
    "zh-TW": zhTW,
    "zh-CN": zhCH,
    "fr": fr,
    "de": de,
    "ru": ru
}
const translator = {
    languages: [
        {
            text: "English",
            value: "en"
        },
        {
            text: "Français",
            value: "fr"
        },
        {
            text: "Deutsch",
            value: "de"
        },
        {
            text: "繁體中文",
            value: "zh-TW"
        },
        {
            text: "简体中文",
            value: "zh-CN"
        },
        {
            text: "Русский",
            value: "ru"
        }

    ],
    texts: {},
    currentLang: "en",
    translate: function (text) {
        let overrides=store.getters&&store.getters.labelTextOverride
        let localeKeyed=overrides&&this.languages.some(language => {
            let localeOverride=overrides[language.value]
            return localeOverride&&typeof localeOverride === "object"&&!Array.isArray(localeOverride)
        })

        if(localeKeyed){
            let localeOverrides=overrides[this.currentLang]
            if(localeOverrides&&typeof localeOverrides[text] === "string"){
                return localeOverrides[text]
            }
            if(this.currentLang === "en") return text
            return this.texts[text] ? this.texts[text] : text
        }

        let label = text
        if(overrides&&typeof overrides[label] === "string") label=overrides[label]
        if (this.currentLang === "en"){
            return label
        }
        return this.texts[label] ? this.texts[label] : label
    },
    setup: function () {
        let defaultLanguage=process.env.VUE_APP_DEFAULT_LANGUAGE&&process.env.VUE_APP_DEFAULT_LANGUAGE!=="" ? process.env.VUE_APP_DEFAULT_LANGUAGE : "en"
        let storedLang = localStorage.getItem('currentLang')
        if (!storedLang || this.languages.filter(x => x.value === storedLang).length === 0) {
            storedLang = defaultLanguage
            localStorage.setItem('currentLang', defaultLanguage)
        }
        this.currentLang = storedLang
        if (storedLang !== "en") {
            this.texts = textmap[storedLang]
        }
    }
}


export default translator
